import { createI18n } from 'vue-i18n'
import daDK from '@/assets/internationalization/da-DK.json'
import deDE from '@/assets/internationalization/de-DE.json'
import enGB from '@/assets/internationalization/en-GB.json'
import svSE from '@/assets/internationalization/sv-SE.json'

const isProductionENV = process.env.NODE_ENV === 'production'

const i18n = createI18n({
	fallbackLocale: 'en-GB',
	locale: navigator.language,
	messages: {
		'da-DK': daDK,
		'de-DE': deDE,
		'en-GB': enGB,
		'sv-SE': svSE,
	},
	silentFallbackWarn: isProductionENV,
	silentTranslationWarn: isProductionENV,
})

export default i18n
